import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {Button} from 'primereact/button'
import {Sidebar} from 'primereact/sidebar'
import {forwardRef, useImperativeHandle} from 'react'
import {ReactComponent as FaUserInjured} from '../../../assets/icons/FaUserInjured.svg'
import TranslateUtils from '../../../i18n/TranslateUtils'

import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../../utils/BlockScrollsUtils'
import useWindowSize from '../../../utils/useWindowSize'
import ParameterForm from '../../parameter/ParameterForm'
import {usePatientContext} from '../information/StyleDetailInformationWrapper'

const StyledParameterSideBar = forwardRef((props, ref) => {
    useSignals()
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))

    const {currentViewedUser} = usePatientContext()
    const {translateDatatable} = TranslateUtils()
    const width = useWindowSize()
    const visible = useSignal(false)

    const handleShowForm = () => {
        blockOverflownScroll()
        visible.value = true
    }
    const handleHideForm = () => {
        unblockOverflownScroll()
        visible.value = false
    }
    return (
        <Sidebar
            id="sidebar-advanced-filter"
            className="sidebar-filter"
            visible={visible.value}
            onHide={handleHideForm}
            showCloseIcon={true}
            blockScroll
            fullScreen={width <= 600}
            position="right"
            baseZIndex={122}>
            <div className="py-2 px-1">
                {/* Header */}
                <div className="flex align-items-center">
                    <div className="mr-2">
                        {/* <FileIcon style={{fontSize: '26px'}} /> */}
                    </div>
                    <div className="flex align-items-center">
                        <span className="mr-3 pt-1">
                            <FaUserInjured
                                style={{width: '24px', height: '24px'}}
                                className="pt-1"
                            />
                        </span>
                        <h3 className="font-bold m-0">Parameter</h3>
                    </div>
                </div>
                <div>
                    <p>
                        Review the patient's symptom report history throughout
                        the monitoring and treatment process, allowing the HCP
                        to closely track and provide accurate diagnoses of the
                        condition.
                    </p>
                </div>
                <hr />
                {/* Content */}
                <div
                    className="relative"
                    style={{
                        overflowY: 'hidden',
                    }}>
                    <ParameterForm />
                </div>
                <hr />
                {/* Footer */}
                <div className="my-2">
                    <Button
                        label={translateDatatable('Close').toUpperCase()}
                        icon="pi pi-times"
                        className="col-12 p-button-lg p-button-outlined font-bold mb-2"
                        onClick={() => {
                            handleHideForm()
                        }}
                    />
                </div>
            </div>
        </Sidebar>
    )
})

export default StyledParameterSideBar
